const ACCESS_TOKEN_KEY = 'wavelink_access_token';
const SESSION_EXPIRES_AT_KEY = 'wavelink_session_expires_at';

/** 旧版存储 Key，迁移后清除 */
const LEGACY_KEYS = ['token', 'refreshToken', 'tokenExpiresAt'] as const;

let memoryAccessToken: string | null = null;

function readSession(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeSession(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch (error) {
    console.warn(`写入 sessionStorage(${key}) 失败:`, error);
  }
}

function removeSession(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}

function notifyTokenChanged(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('auth-token-changed'));
  }
}

function clearLegacyLocalStorage(): void {
  try {
    for (const key of LEGACY_KEYS) {
      localStorage.removeItem(key);
    }
  } catch {
    // ignore
  }
}

/**
 * 将旧版 localStorage Token 迁移到 sessionStorage
 */
export function migrateLegacyTokens(): void {
  try {
    const legacyAccess = localStorage.getItem('token');
    const legacyExp = localStorage.getItem('tokenExpiresAt');

    if (legacyAccess && !readSession(ACCESS_TOKEN_KEY)) {
      memoryAccessToken = legacyAccess;
      writeSession(ACCESS_TOKEN_KEY, legacyAccess);
    }
    if (legacyExp && !readSession(SESSION_EXPIRES_AT_KEY)) {
      writeSession(SESSION_EXPIRES_AT_KEY, legacyExp);
    }

    if (legacyAccess || localStorage.getItem('refreshToken') || legacyExp) {
      clearLegacyLocalStorage();
    }
  } catch (error) {
    console.warn('Token 迁移失败:', error);
  }
}

export const secureTokenStorage = {
  getAccessToken(): string | null {
    if (memoryAccessToken) {
      return memoryAccessToken;
    }
    const stored = readSession(ACCESS_TOKEN_KEY);
    if (stored) {
      memoryAccessToken = stored;
    }
    return stored;
  },

  getSessionExpiresAt(): number | null {
    const stored = readSession(SESSION_EXPIRES_AT_KEY);
    if (!stored) {
      return null;
    }
    const parsed = parseInt(stored, 10);
    return Number.isNaN(parsed) ? null : parsed;
  },

  setAccessToken(accessToken: string, expiresInSeconds?: number): void {
    memoryAccessToken = accessToken;
    writeSession(ACCESS_TOKEN_KEY, accessToken);

    if (expiresInSeconds && expiresInSeconds > 0) {
      writeSession(SESSION_EXPIRES_AT_KEY, String(Date.now() + expiresInSeconds * 1000));
    }

    clearLegacyLocalStorage();
    notifyTokenChanged();
  },

  clearTokens(): void {
    memoryAccessToken = null;
    removeSession(ACCESS_TOKEN_KEY);
    removeSession(SESSION_EXPIRES_AT_KEY);
    clearLegacyLocalStorage();
    notifyTokenChanged();
  },

  hasAccessToken(): boolean {
    return Boolean(this.getAccessToken());
  },
};
